import React from "react";
import type { CellSaveStatus } from "../../hooks/useCellSaveState";
import {
  CheckIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/20/solid";

/**
 * Compact, accessible feedback for inline table saves.
 */
export default function CellSaveStatusIndicator({ status = "idle" }: { status?: CellSaveStatus }) {
  const label = {
    idle: undefined,
    saving: "Saving",
    saved: "Saved",
    error: "Save failed",
  }[status];

  const indicator = {
    idle: null,
    saving: (
      <span
        className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-gray-300 border-t-indigo-600"
        aria-hidden="true"
      />
    ),
    saved: <CheckIcon className="h-4 w-4 text-green-600" aria-hidden="true" />,
    error: (
      <ExclamationCircleIcon
        className="h-4 w-4 text-red-600"
        aria-hidden="true"
      />
    ),
  }[status];

  return (
    <span
      className="inline-flex h-4 w-4 shrink-0 items-center justify-center"
      role={label ? "status" : undefined}
      aria-label={label}
      title={label}
    >
      {indicator}
    </span>
  );
}
